import React, { useEffect, useState } from 'react'
import { BoxOptions, BoxProduct, Container, IconFile, ItemAction, ItemOption, MenuItens, Name, SectionActions, SectionAnexos, SectionImage, SectionInfor } from './styled'

import { AiOutlinePaperClip, AiOutlinePlus, AiOutlineReload, } from "react-icons/ai";
import { IoIosArrowForward, IoIosArrowDown } from "react-icons/io";
import { BsFileEarmarkImageFill, BsFileEarmarkPdfFill, BsFillFileEarmarkPlayFill, BsFileEarmarkArrowDownFill, BsLink45Deg, BsFillFileEarmarkFill } from "react-icons/bs";
import ModalUploadAnexo from '../modal-upload-anexo';
import ModalConectarAnexo from '../modal-conectar-anexo';
import ModalVincularAnexo from '../modal-vincular-anexo';
import CardVariente from '../card-variante';
import ModalConfirmation from "../../../../components/Modal-Confirmation";
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import IconUrl from "../../../../assets/imgs/icons/code.svg";
import IconDefault from "../../../../assets/imgs/icons/default.svg"
import IconDoc from "../../../../assets/imgs/icons/doc.svg";
import IconVideo from "../../../../assets/imgs/icons/videoplay.svg";
import IconImage from "../../../../assets/imgs/icons/image.svg";
import IconPdf from "../../../../assets/imgs/icons/pdf.svg";
import { FiCameraOff } from 'react-icons/fi';
import { translations } from '../../../../utils/language';
import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import { Message } from '../tailwind/item-table/styled';

const CardProductTable = (props) => {

    const [visibleOptions, setvisibleOptions] = useState(false)
    const [visibleModalUpload, setVisibleModalUpload] = useState(false)
    const [visibleModalVincular, setVisibleModalVincular] = useState(false)
    const [visibleModalConectar, setVisibleModalConectar] = useState(false)
    const [selectedVariante, setSelectedVariante] = useState("")
    const iconFile = { size: 20, color: "#808080" }
    const [deleteMedia, setDeleteMedia] = useState(null)

    const language = useSelector((state) => state.reducerLanguage);

    const [visibleMenu, setVisibleMenu] = useState(false)
    const [visibleMenuVariant, setVisibleMenuVariant] = useState(false)
    const [visibleModalConfirmation, setVisibleModalConfirmation] = useState(false)

    const statusRemoveLink = useSelector((state) => state.reducerControlRemoveLink);

    const dispatch = useDispatch()

    return (
        <div style={{ border: "1px solid #f2f2f2", marginBottom: "16px" }} className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
            <span style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                {props?.item?.image_url ?
                    <img onClick={() => { window.open(props?.item?.canonical_url, '_blank') }} style={{ cursor: "pointer", width: "32px", height: "32px", objectFit: "cover", borderRadius: "4px" }} src={props?.item?.image_url} /> :
                    <ShoppingBagIcon style={{ height: "32px" }} />}
                <Message>
                    <label onClick={() => { window.open(props?.item?.canonical_url, '_blank') }} >
                        {props?.item?.name}
                    </label>
                </Message>
            </span>
        </div>
    )
}

export default CardProductTable